query getEmails($limit: Int, $offset: Int, $order: JSON) {
    getEmails(limit: $limit, offset: $offset, order: $order) {
        id
        email
        subscription
        is_registered
        timestamp
    }
}
